/* eslint-env browser */
import * as React from 'react'

import withTranslator from '../TranslatorProvider'

const PropTypes = require('prop-types')
const classNames = require('classnames')

class StarsDisplay extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  render() {
    let { note, maxNote, count } = this.props
    const { isSmall, showNote, translate, isAverage, isReviewRating } = this.props
    note = Number(note)
    maxNote = Number(maxNote)
    count = Number(count)
    return (
      <span
        {...(isReviewRating && count > 0
          ? {
              itemProp: 'reviewRating',
              itemScope: true,
              itemType: 'http://schema.org/Rating',
            }
          : {})}
        {...(isAverage && count > 0
          ? {
              itemProp: 'aggregateRating',
              itemScope: true,
              itemType: 'http://schema.org/AggregateRating',
            }
          : {})}
      >
        {isReviewRating &&
          count > 0 && [
            <meta key="worst" itemProp="worstRating" content="1" />,
            <meta key="value" itemProp="ratingValue" content={note} />,
            <meta key="best" itemProp="bestRating" content={maxNote} />,
          ]}
        {Array.from(Array(maxNote))
          .map(Number.call, Number)
          .map((el, index) => (
            <span
              key={`starScore-${el}-forForm`}
              className={classNames('icon', {
                'is-small': isSmall,
              })}
              style={{ color: 'gold' }}
            >
              <i
                className={classNames({
                  'far fa-star': note < index + 1,
                  'fas fa-star': note >= index + 1,
                  'fas fa-star-half-alt': note < index + 1 && note >= index + 0.5,
                })}
              />
            </span>
          ))}
        &nbsp;
        {(showNote && Number(note)) > 0 && (
          <small>
            <span {...(isAverage && count > 0 ? { itemProp: 'ratingValue' } : {})}>{Number(note).toFixed(1)}</span>
            {`/${maxNote}`}
          </small>
        )}
        &nbsp;
        {count > 0 && (
          <small {...(isAverage && count > 0 ? { itemProp: 'reviewCount', content: count } : {})}>
            {translate(`opinions.count.${count > 1 ? 'plural' : 'singular'}`, { count })}
          </small>
        )}
      </span>
    )
  }
}

StarsDisplay.propTypes = {
  note: PropTypes.number.isRequired,
  maxNote: PropTypes.number.isRequired,
  isSmall: PropTypes.bool,
  isAverage: PropTypes.bool,
  isReviewRating: PropTypes.bool,
  showNote: PropTypes.bool,
  count: PropTypes.number,
  translate: PropTypes.func.isRequired,
}

StarsDisplay.defaultProps = {
  isSmall: false,
  showNote: false,
  isAverage: false,
  isReviewRating: false,
  count: 0,
}

module.exports = withTranslator(StarsDisplay)
